<template>
  <v-container fluid>
    <v-row v-if="videos.length">
      <v-col
        v-for="(video, index) in videos"
        :key="index"
        cols="4"
        sm="3"
        md="2"
        lg="2"
        class="p-05"
        style="position: relative"
      >
        <div class="dd-container" ref="dropdown">
          <v-icon
            class="dots-v"
            dark
            @click="showMenuIndex = showMenuIndex === index ? null : index"
            v-if="personData.userId == currentUser.id"
          >
            mdi-dots-vertical
          </v-icon>
          <v-list dense class="pb-0 dd-list" v-if="showMenuIndex == index">
            <v-list-item dense @click="emitDeleteVideo(video.id)">
              <v-list-item-title>{{
                lang.actions.deleteVideo
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </div>
        <div class="entity-container">
          <video
            style="width: 100%"
            @click="emitVideoShow(video.id, index)"
            controlsList="nodownload"
            :key="video.videoUrl"
          >
            <source :src="video.videoUrl" type="video/mp4" />
            <source :src="video.videoUrl" type="video/webm" />
            <source :src="video.videoUrl" type="video/ogg" />
            <source :src="video.videoUrl" type="video/quicktime" />
            <source :src="video.videoUrl" type="video/x-msvideo" />
            <source :src="video.videoUrl" type="video/x-matroska" />
            Your browser does not support the video tag.
          </video>
        </div>
      </v-col>
    </v-row>
    <NoResult
      v-else
      class="mt-0"
      :show="true"
      :title="lang.profile.noData"
    ></NoResult>
  </v-container>
</template>

<script>
import NoResult from "../../components/noResult";
export default {
  data() {
    return {
      showMenuIndex: null,
    };
  },
  props: {
    videos: {
      type: Array,
      default() {
        return [];
      },
    },
    personData: {
      type: Object,
      default() {
        return {};
      },
    },
    currentUser: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    emitVideoShow(id, index) {
      this.$emit(
        "emitVideoShow",
        this.$route.path.includes("demo") ? index : id
      );
    },
    emitDeleteVideo(id) {
      this.$emit("emitDeleteVideo", id);
    },
    handleClickOutside(event) {
      const dropdowns = this.$refs.dropdown;
      if (!dropdowns) return;
      const isOutsideClick = !Array.from(dropdowns).some((dropdown) =>
        dropdown.contains(event.target)
      );

      if (isOutsideClick) {
        this.showMenuIndex = null;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  components: {
    NoResult,
  },
};
</script>

<style lang="scss" scoped>
.p-05 {
  padding: 1px;
}
.dd-container {
  position: absolute;
  right: 0;
  .dd-list {
    position: absolute;
    top: 35px;
    z-index: 5;
    right: 10px;
    padding-top: 0;
  }
}
.dots-v {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
}
.entity-container {
  background: black;
  display: flex;
  align-content: center;
  justify-content: center;
  height: 212px;
  cursor: pointer;
}
</style>